export const OrderEnum = {
    New: 0,
    Pending: 1,
    Approved: 2,
    Cancelled: 3
}